import React from 'react'
import { Form, label } from "react-bootstrap";
import {StyleSheet, css} from 'aphrodite'
import "./customRadioButton.css";
class CustomRadioButton extends React.Component {
  
  state = {
    active: false
  }

  handleChange = (val, fieldName, callback) => {
    callback(fieldName, val);
  };

  render(){
    //const checkStyle = this.state.active ? style.active : style.disabled
    //const checkStyleInternal = this.state.active ? style.intActive : style.intDisabled
    const { name, action, label, value, checked, inline, type, disabled } = this.props;
    return (
      <div>
        <Form.Check 
        inline={inline}
        type={type}
        label={label}
        value={value}
        checked={checked}
        className={css(style.labelstyle)}
        onChange={(checked) => this.handleChange(checked, name, action)}
        disabled={disabled}
        />
      </div>
    )
  }
}

export default CustomRadioButton

const style = StyleSheet.create({
  labelstyle: {
    //fontSize: "13px",
    color: "#2e2e2e",
    //marginLeft: "5px",
    verticalAlign: "top",
    //cursor: "pointer",
  },
  
})

